module.exports = __webpack_public_path__ + "img/1.1b5d7f59.jpg";